import { useTranslation } from 'react-i18next';
import { Button, ButtonProps } from './button';

export type ButtonSubmitProps = ButtonProps;

export const ButtonSubmit = ({ loading, ...restProps }: ButtonSubmitProps) => {
  const { t } = useTranslation();

  return (
    <Button
      type="submit"
      variant="solid"
      loading={{
        title: t('Button.Submitting'),
        ...(typeof loading === 'boolean' ? { status: loading } : loading)
      }}
      {...restProps}
    />
  );
};
